exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.NotificationFilters{align-self:stretch\n}\n.NotificationFilters>button{font-size:1.2em;padding-left:.7em;padding-right:.2em;line-height:100%;height:100%\n}\n.NotificationFilters .dropdown-item{margin:0\n}", ""]);

// exports
